import React from 'react';
import { Space, Input, Button, DatePicker } from 'antd';
import { Label } from '../Layouts';
import dayjs from 'dayjs';
import ProjectLookup from '../common/ProjectLookup';

const LogFilter: React.FC<{
    values: Partial<SearchLogParams>,
    onSearch: () => void,
    onChange: (v: Partial<SearchLogParams>) => void,
    slot?: React.ReactElement,
}> =
    ({ values: params, slot, onChange: setParams, onSearch }) => {
        return (
            <Space>
                <Label>
                    <Label>展会名称</Label>
                    <ProjectLookup history style={{ minWidth: 200 }} placeholder='请输入展会名称' value={params.projectId} onChange={projectId => {
                        setParams({
                            ...params,
                            projectId
                        })
                    }} />
                </Label>
                <Label>
                    <Label>设备序列号</Label>
                    <Input.Search placeholder='请输入设备序列号' value={params.devSn}
                        onSearch={onSearch}
                        onChange={e => {
                            setParams({
                                ...params,
                                devSn: e.target.value
                            })
                        }} />
                </Label>
                <Label>
                    <Label>网关MAC</Label>
                    <Input.Search placeholder='请输入MAC地址' value={params.gwMac}
                        onSearch={onSearch}
                        onChange={e => {
                            setParams({
                                ...params,
                                gwMac: e.target.value
                            })
                        }} />
                </Label>
                <Label>
                    <Label>开关号</Label>
                    <Input.Search placeholder='请输入开关号' value={params.switchNumber}
                        onSearch={onSearch}
                        onChange={e => {
                            setParams({
                                ...params,
                                switchNumber: e.target.value ? Number(e.target.value) : undefined
                            })
                        }} />
                </Label>

                <Label>
                    <Label>接收时间</Label>
                    <DatePicker.RangePicker
                        showTime
                        needConfirm={false}
                        value={[
                            params.receivedStartDate ? dayjs(params.receivedStartDate) : null,
                            params.receivedEndDate ? dayjs(params.receivedEndDate) : null,
                        ]}
                        onChange={(_, [receivedStartDate, receivedEndDate]) => {
                            setParams({
                                ...params,
                                receivedStartDate: receivedStartDate || undefined,
                                receivedEndDate: receivedEndDate || undefined
                            })
                        }}
                        placeholder={['接收时间(起)', '接收时间(止)']} />
                </Label>
                <div style={{ marginTop: '1.4em', display: 'flex', alignItems: 'center' }} >
                    <Button onClick={onSearch} type='primary'>查询</Button>
                    {slot}
                </div>
            </Space>
        );
    }

export default LogFilter;